// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1enUZ","active":"NavigationItem_active__2qkmh"};